import ApiClient from './ApiClient';

class AuthClient {
  constructor() {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api/v1';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.params = {};
  }

  logUserIn(oktaCode, redirectUri) {
    const dataBody = {
      Code: oktaCode,
      RedirectUri: redirectUri,
    };
    return this.apiClient.post(`${this.baseUri}api/v1/token`, dataBody, this.headers)
      .then((response) => {
        if (response === 'There was problem processing your request. Please try again or adjust your parameters.') {
          /* eslint-disable-next-line no-alert */
          alert('Please reach out to the Hackathon Committee to verify your access.');
        }
        return response.data;
      });
  }

  refreshTokens(refreshToken, redirectUri) {
    const dataBody = {
      Code: refreshToken,
      RedirectUri: redirectUri,
    };
    return this.apiClient.post(`${this.baseUri}api/v1/token/refresh?grant_type=refresh_token`, dataBody, this.headers)
      .then((response) => response.data);
  }
}
export default AuthClient;
